import type { SerializedHardwarePackage } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateHardwarePackageArgs } from 'lib/services/hardwarePackagesApi';
import { type MutationOptions, useMutation, type UseMutationResult } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS } from 'utils/queryKeys';

export const useUpdateHardwarePackage = ({
  onSuccess,
}: Pick<
  MutationOptions<SerializedHardwarePackage, unknown, UpdateHardwarePackageArgs>,
  'onSuccess'
> = {}): UseMutationResult<SerializedHardwarePackage, unknown, UpdateHardwarePackageArgs> => {
  const { hardwarePackagesApiClient } = useServices();
  const appNotification = useAppNotifications();

  return useMutation(async (arg: UpdateHardwarePackageArgs) => await hardwarePackagesApiClient.update(arg), {
    mutationKey: MUTATION_KEYS.hardwarePackages.updateOne(),
    onError: error => {
      appNotification.error({
        message: 'There was an error while updating hardware package',
        description: error instanceof Error ? getErrorMessage(error) : undefined,
      });
    },
    onSuccess: (data, variables, context) => {
      appNotification.success({
        message: `Hardware package updated`,
      });
      onSuccess?.(data, variables, context);
    },
  });
};
